import { useParams, Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";

// WordPress usava permalink datati: /YYYY/MM/DD/slug/ -> /blog/slug (301 SEO)
export default function LegacyBlogRedirect() {
  const { year, slug } = useParams();
  if (/^\d{4}$/.test(year || "") && slug) {
    return <Navigate to={`/blog/${slug}`} replace />;
  }
  return <NotFound />;
}
